import DashboardService from "./DashboardService";
import MetricService from "./MetricService";
export var dashboardService = new DashboardService();
export var metricService = new MetricService();
